import clean from 'lodash-clean';
import get from 'lodash/get';
import { SubmissionError } from 'redux-form';

import {
  BUILDING_STAFF_REQUESTED,
  PMC_STAFF_REQUESTED,
  SELECT_EXISTING_LOAD_PEOPLE,
  STAFF_CREATE_REQUESTED,
  STAFF_MOVE_OUT_FAILURE,
  STAFF_MOVE_OUT_REQUEST,
  STAFF_MOVE_OUT_SUCCESS,
  STAFF_UPDATE_REQUESTED,
  UPDATE_ROLE_FAILURE,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS,
} from '../../actionConstants';
import { uploadImage } from '../Visitor/actionCreators';

import { checkHasRole } from '../Person/utils';
import { sendGA4Event } from '../Shared/utils/ga';

import { roleNames } from '../Person/constants';

import apiClient from '../../apiClient';
import { history } from '../../store';

export const preSubmit = (data) => {
  const {
    primary,
    role,
    allowManageResidents,
    propertyId: property,
    building,
    primaryStaff,
    ...rest
  } = data;

  const isPMSelected =
    checkHasRole(roleNames.pmc_owner, role) ||
    checkHasRole(roleNames.property_manager, role);
  const isSISelected = checkHasRole(roleNames.superintendent, role);

  let properties = [];
  if (primary && isPMSelected) {
    properties = [
      {
        role,
        property,
        primary: true,
        primaryStaff,
      },
    ];
  } else if (!building?.length) {
    properties = [
      {
        role,
        property,
        primary: false,
        primaryStaff,
      },
    ];
  } else {
    properties = building.map((building) => ({
      role,
      property: building,
      primary: false,
      primaryStaff,
    }));
  }
  if (isSISelected && allowManageResidents) {
    properties = properties.map((propertyValues) => ({
      ...propertyValues,
      allowManageResidents,
    }));
  }
  rest.properties = properties;
  return clean(rest);
};

export const createStaff = (dispatch, formattedData, successMessage, images) =>
  dispatch({
    type: STAFF_CREATE_REQUESTED,
    payload: apiClient.staff.create(formattedData),
    successMessage,
    isForm: true,
    callback: async (res) => {
      if (res) {
        const personId = get(res, 'data.id', null);
        const isCreated = get(res, 'data.created', false);
        const isAbleToLoadPhoto = get(res, 'data.isAbleToLoadPhoto', null);
        isCreated && sendGA4Event('created_staff');
        if (personId && isCreated && isAbleToLoadPhoto) {
          const url = `persons/${personId}/photo/`;
          await uploadImage(dispatch, images, url);
          return history.goBack();
        }
        if (!isCreated) {
          dispatch({
            type: SELECT_EXISTING_LOAD_PEOPLE,
            people: res.data.persons,
          });
          throw new SubmissionError({
            _error:
              'Person with that email/phone # exists, please select them from the list',
          });
        }
      }
      return null;
    },
  });

export const addRole = (dispatch, data, callback) =>
  dispatch({
    type: STAFF_UPDATE_REQUESTED,
    payload: apiClient.staff.addRole(data),
    successMessage: `New role added`,
    callback,
  });

export const refetchPMCorBuildingStaff = (dispatch, props) => {
  const { match } = props;
  const buildingId = get(match, 'params.buildingId');
  const PMCId = get(match, 'params.PMCId');
  if (buildingId) {
    return dispatch({
      type: BUILDING_STAFF_REQUESTED,
      buildingId,
      payload: apiClient.building.staffWithoutPagination(buildingId),
    });
  }
  if (PMCId) {
    return dispatch({
      type: PMC_STAFF_REQUESTED,
      PMCId,
      payload: apiClient.pmc.staffWithoutPagination(PMCId),
    });
  }
  return null;
};

export const moveOutStaff = (dispatch, staffId, role) => {
  const formattedData = {
    property: role.propertyId,
    role: role.role,
  };
  return dispatch({
    type: STAFF_MOVE_OUT_REQUEST,
    payload: apiClient.staff.moveOut(staffId, formattedData).then(
      (res) => {
        dispatch({
          type: STAFF_MOVE_OUT_SUCCESS,
          successMessage: 'Staff member successfully moved out',
        });
        return res;
      },
      (err) =>
        dispatch({
          type: STAFF_MOVE_OUT_FAILURE,
          err,
        }),
    ),
  });
};

export const updateStaffRole = (dispatch, personRoleId, data) =>
  dispatch({
    type: UPDATE_ROLE_REQUEST,
    payload: apiClient.staff
      .updateRole(personRoleId, data)
      .then((res) =>
        dispatch({
          type: UPDATE_ROLE_SUCCESS,
          res,
        }),
      )
      .catch((err) =>
        dispatch({
          type: UPDATE_ROLE_FAILURE,
          err,
        }),
      ),
  });
